export enum ECoachTicketStatus {
  /** Waiting for an answer from the central team. */
  WaitingReply = 1,
  /** Answered by the central team. */
  Answered = 2,
  Closed = 3,
}
